import { Badge } from 'antd';
// BBART-2261: Diamond icon removed per client request
// import { SketchLogo } from 'phosphor-react';
import {
  MEMBERS_ONLY,
  PLAN_UPGRADE_REQUIRED,
  SUBSCRIPTION_PLAN_KEYS
} from '../common/constants';
import { useApp } from '../providers/AppContext';

// BBART-2261: showIcon prop removed along with diamond icon per client request
export default function MembersBadge({ allowedPlans }) {
  const {
    state: { currentUser, isAuthenticated, loading }
  } = useApp();

  const userPlan = currentUser?.effectivePlan;

  if (
    allowedPlans?.length &&
    userPlan &&
    allowedPlans.some((p) => p.key === userPlan)
  ) {
    return null;
  }

  const isPlanMismatch =
    isAuthenticated &&
    ![SUBSCRIPTION_PLAN_KEYS.FREE, SUBSCRIPTION_PLAN_KEYS.GUEST].includes(
      userPlan
    );

  const getBadgeLabel = () => {
    if (loading) return 'Loading...';
    if (isPlanMismatch) return PLAN_UPGRADE_REQUIRED;
    return MEMBERS_ONLY;
  };

  return (
    <Badge className="badge-md text-white-90 bg-n-900 premium-tag ml-4">
      {/* BBART-2261: Diamond icon removed per client request */}
      {/* {showIcon && <SketchLogo size={18} />} */}
      <span className="text-label-xs">{getBadgeLabel()}</span>
    </Badge>
  );
}
